// extracted by mini-css-extract-plugin
export default {"circle":"HighlightCircle_circle__Me7gF","wave":"HighlightCircle_wave__2IYaX"};